import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Badge } from 'primereact/badge';

import './PanelOperacionesEstatusRutasShow.scss';
import logo from '../../../assets/img/logo.png';
import BotonDescargarExel from '../../../components/atoms/BotonDescargarExel/BotonDescargarExel';
import { useParams } from 'react-router-dom';
import { getDataFecha, getDataRealTime } from './integracion';
import Boton from "../../../components/atoms/Boton/Boton";
import Loader from "../../../components/molecules/Loader/Loader";

const PanelOperacionesEstatusRutasShow = () => {
    const params = useParams();
    const [fechas, setFechas] = useState();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');

    useEffect(() => {
        if (params.opcion !== '0') {
            setFechas(params.opcion.split("_"));
        } else {
            setFechas("0");
        }
    }, [params.opcion]);

    useEffect(() => {
        if (fechas) {
            setLoading(true);
            if (fechas === "0") {
                getDataRealTime(setData, setLoading);
            } else {
                getDataFecha(fechas[0], fechas[1], setData, setLoading);
            }
        }
    }, [fechas]);

    useEffect(() => {
        const dropdowns = document.querySelectorAll('.p-dropdown-label');
        dropdowns.forEach(dropdown => {
            if (dropdown.textContent === 'Choose') {
                dropdown.textContent = 'Seleccionar';
            }
        });
    }, []);

    const renderStatusTemplate = (rowData) => {
        return (
            <Badge value={rowData.ESTATUS} severity={rowData.ESTATUS === 'NO CONFIRMADA' ? 'danger' : rowData.ESTATUS === 'EN TIEMPO' ? 'success' : "warning"} />
        );
    };

    const renderUnitStatus = (rowData) => {
        const statusText = rowData.ON === 1 ? 'ENCENDIDA' : rowData.ON === 0 ? 'APAGADA' : 'DESCONOCIDO';
        const severity = rowData.ON === 0 ? 'danger' : rowData.ON === 1 ? 'success' : 'warning';

        return (
            <Badge value={statusText} severity={severity} />
        );
    };

    const filteredData = data.filter(row =>
        Object.values(row).some(value =>
            String(value).toLowerCase().includes(globalFilter.toLowerCase())
        )
    );

    const header = (
        <div className='header-datatable-container'>
            <InputText
                type="search"
                value={globalFilter}
                onChange={(e) => setGlobalFilter(e.target.value)}
                placeholder="Buscar"
                className='buscador'
                size="50"
            />
            <div className="botonDescargarExel">
                <BotonDescargarExel nombreArchivo={"estatus de rutas"} datos={data} />
            </div>
            {
                fechas === "0" && (
                    <div className="botonDescargarExel">
                        <Boton className="boton" onClick={() => {
                            setLoading(true);
                            getDataRealTime(setData, setLoading)}}>
                            Recargar datos
                        </Boton>
                    </div>
                )
            }
        </div>
    );

    return (
        <div className="Home">
            {loading && <Loader />}
            <div>
                <div className="card">
                    {/* datatable */}
                    <DataTable
                        value={filteredData}
                        paginator
                        rows={10}
                        className="datatable-ruta"
                        rowsPerPageOptions={[10, 20, 50]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        header={header}
                        emptyMessage="No hay resultados"
                        scrollable
                        scrollHeight="100%"
                    >
                        <Column field="ID_BITACORA" header="BITACORA"
                                body={rowData => <span data-header="BITACORA">{rowData.ID_BITACORA}</span>}/>
                        <Column field="ID_UNIDAD" header="UNIDAD"
                                body={rowData => <span data-header="UNIDAD">{rowData.ID_UNIDAD}</span>}/>
                        <Column field="OPERADOR" header="OPERADOR"
                                body={rowData => <span data-header="OPERADOR">{rowData.OPERADOR}</span>}/>
                        <Column field="TELEFONO ?? 'NO DEFINIDO'" header="TELÉFONO"
                                body={rowData => <span data-header="TELÉFONO">{rowData.TELEFONO ?? 'NO DEFINIDO'}</span>}/>
                        <Column field="ESTATUS RUTA" header="ESTATUS RUTA" filterField="ESTATUS RUTA"
                                body={rowData => <span
                                    data-header="ESTATUS RUTA">{renderStatusTemplate(rowData)}</span>}/>
                        {data[0]?.hasOwnProperty('ON') && (
                            <Column field="ON" header="ESTATUS UNIDAD" filterField="ON" body={rowData => <span
                                data-header="ESTATUS UNIDAD">{renderUnitStatus(rowData)}</span>}/>
                        )}
                        {data[0]?.hasOwnProperty('FUEL') && (
                            <Column field="FUEL" header="CANTIDAD COMBUSTIBLE"
                                    body={rowData => <span data-header="CANTIDAD COMBUSTIBLE">{rowData.FUEL}</span>}/>
                        )}
                        <Column field="RUTA" header="RUTA"
                                body={rowData => <span data-header="RUTA">{rowData.RUTA}</span>}/>
                        <Column field="HORA_ARRANQUE" header="HORA DE ARRANQUE"
                                body={rowData => <span data-header="HORA DE ARRANQUE">{rowData.HORA_ARRANQUE}</span>}/>
                        <Column field="HORA_INICIO_RUTA" header="HORA DE INICIO"
                                body={rowData => <span data-header="HORA DE INICIO">{rowData.HORA_INICIO_RUTA}</span>}/>
                        <Column field="HORA_FIN" header="HORA FIN"
                                body={rowData => <span data-header="HORA FIN">{rowData.HORA_FIN}</span>}/>
                        <Column field="FECHA" header="FECHA"
                                body={rowData => <span data-header="FECHA">{rowData.FECHA}</span>}/>
                    </DataTable>
                </div>
            </div>
        </div>
    );
};

export default PanelOperacionesEstatusRutasShow;
